import React from "react";

const ServicesProcess = ({ title, subtitle, processData }) => {
  return (
    <section className="planning-section-process services-section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-9 mb-4 mb-lg-0 position-relative text-center">
            <h2 className="title">{title || "Web Development Process"}</h2>
            <p className="sub-title text-black mt-2">
              {subtitle ||
                "Our structured development process ensures high-quality, secure, and scalable web solutions delivered on time."}
            </p>
          </div>
        </div>

        <div className="process-grid">
          {processData && processData.length > 0 ? (
            processData.map((item, index) => (
              <div key={index} className="process-card-services">
                <div className="process-icon">
                  <img src={item.icon} alt={item.title} />
                </div>
                <div className="process-step">{index + 1}</div>
                <div className="process-title">{item.title}</div>
                <div className="process-underline-flex">
                  <div className="process-underline"></div>
                  <div className="process-underline"></div>
                </div>
                <div className="process-desc">{item.description}</div>
              </div>
            ))
          ) : (
            <p>No process data available</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServicesProcess;
